import { COLOR_OPTIONS } from 'config/style';
import STTypo, { STTypoModels } from 'core/shared/typo';
import type { IRegionalRiskPopupProperty } from '@features/regional-overview/regional-overview.models';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface TypeRegionalRiskPopupProperty {
  properties: IRegionalRiskPopupProperty;
}

const RegionalRiskPopupProperty: React.FC<TypeRegionalRiskPopupProperty> = ({ properties }) => {
  const [t] = useTranslation();
  return (
    <div className='sd-regional-risk-popup'>
      <div className='sd-regional-risk-popup__header'>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo
            type={STTypoModels.TypeOptions.H5}
            data-testid='regional-risk-popup-property-title'
            color={COLOR_OPTIONS.PRIMARY}
            fontWeight={500}>
            {properties.propertyName}
          </STTypo>
        </div>
        <div className='sd-regional-risk-popup__header-line'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.SECONDARY}>
            {properties.amountFields} {t('pages.regional_overview.regional_risk.areas')}
            {properties.amountFields > 1 ? 's' : ''}
          </STTypo>
        </div>
      </div>
    </div>
  );
};

export default RegionalRiskPopupProperty;
